import Vimeo from '@vimeo/player'
window.Vimeo = Vimeo;

let videoLength = 0;
let timeWatched = 0;
let lastPercSent = 0;
let isWatched = false;
let iframe = null;
const sendEvery = 1;

function getPerc() {
    return Math.round(timeWatched / ( videoLength / 100 ));
}

function updateStatus() {
    if(videoLength!==0 && timeWatched!==0) {
        let perc_watched = getPerc();

        if(/*isWatched===false &&*/ perc_watched >= (lastPercSent+sendEvery) && perc_watched >= minim_video_percentage_watch) {
            isWatched = true;
            lastPercSent = perc_watched;

            axios.post(iframe.dataset.url, {
                percentage: perc_watched
            })
            .then(function (response) {
                //console.log(response);
                if(response.data.success) {
                    $('.confirmVideo').show();
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    }
}

// https://github.com/vimeo/player.js
$(document).ready(function(){
    iframe = document.querySelector('iframe.embed-responsive-item');
    if (iframe) {
        const player = new Vimeo(iframe);
        player.on('play', function (data) {
            /*console.log('played the video!');
            console.log(data);*/
            videoLength = data.duration;
        });
        player.on('pause', function (data) {
            /*console.log('pause the video!');
            console.log(data);*/
            updateStatus();
        });
        player.on('ended', function (data) {
            /*console.log('end the video!');
            console.log(data);*/
            updateStatus();
        });

        player.on("timeupdate", function (data) {
            if (data.seconds - 1 < timeWatched && data.seconds > timeWatched) {
                timeWatched = data.seconds;
                /* This prevents seeking. The reason this is needed
                is because when the user tries to seek, a time update is called which results in the
                watchedTime becoming the same as the seeked time before it goes into the function 'seeked' (below) resulting
                in both values being the same. We need to get the most recent time update before the seek.
                (data.seconds - 1 < currentTime) basically if you seek, this will return false and the current time wont get updated
                (data.seconds > currentTime) if they seek backwards then dont update current time so they can seek back to where they were before*/
            }
            updateStatus();
        });

        player.on("seeked", function (data) {
            if (timeWatched < data.seconds) {
                player.setCurrentTime(timeWatched);
            }
        });
    }
});
